import styled, { css } from 'styled-components';

export const Container = styled.div<{ $align: string }>`
  background-color: ${({ theme }) => theme.background};
  position: absolute;
  top: 45px;
  right: 0;
  padding: 5px 10px;
  border-radius: 10px;
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  width: 300px;
  z-index: 10;
  display: flex;
  flex-direction: column;

  a {
    border-bottom: 1px solid ${({ theme }) => theme.keyline};
    padding: 8px 0;
    width: 100%;
    display: block;
    text-align: center;
    color: ${({ theme }) => theme.textDark};
  }

  a:last-child {
    border-bottom: none;
  }

  ${({ $align }) =>
    $align === 'right'
      ? css`
          right: 0;
        `
      : `
    left: 0;
  `}

  &:before {
    content: '';
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${({ theme }) => theme.background};
    top: -10px;
    position: absolute;

    ${({ $align }) =>
      $align === 'right'
        ? css`
            right: 20px;
          `
        : `
      left: 20px;
    `}
  }
`;

export default Container;
